import Decimal from 'decimal.js';
import { getLocalCountry } from '@/utils/common.utils';
import { CountryCodeEnum } from '@/const/country.const';

/** 網站使用貨幣 enum */
export enum CurrencyEnum {
  // 巴西幣
  BRL = 'BRL',
  // 尼日利亚奈拉
  // NGN = 'NGN',
  // 阿根廷比索
  // ARS = 'ARS',
  // 加密貨幣(USDT)
  // USDT = 'USDT',
  USD = 'USD',
  // 南非币
  ZAR = 'ZAR',
  // 墨西哥币
  MXN = 'MXN'
}

/**
   * 货币符号 https://001thebest.atlassian.net/wiki/spaces/001THEBEST/pages/86475164/-
   */
export const CurrencySymbolMap: Record<CurrencyEnum, string> = {
  BRL: 'R$',
  MXN: '$',
  USD: '$',
  ZAR: 'R'
};

/** 貨幣類別 */
export enum CurrencyTypeEnum {
  // 國家貨幣類別
  Currency = 1,
  // 加密貨幣類別
  Crypto = 2
}

export interface CurrencyOption {
  /** 是否啟用 */
  active: boolean;
  currency: CurrencyEnum;
  type: CurrencyTypeEnum;
  class: string;
}

export const currencyOptions: CurrencyOption[] = [
  {
    active: true,
    currency: CurrencyEnum.BRL,
    type: CurrencyTypeEnum.Currency,
    class: 'tw-bg-app-yellow-2'
  }

];
export enum CurrencyRateEnum {
  USD = 'USD',
  EUR = 'EUR',
  ZAR = 'ZAR',
  BRL = 'BRL',
  MXN = 'MXN'
}

const currencyArray = [
  'BRL', 'NGN', 'ARS', 'USDT', 'ZAR', 'MXN'
];
const currencyRateArray = [
  'USD', 'EUR', 'ZAR', 'BRL', 'MXN'
];

export const countryCurrencyOptions = getLocalCountry() ===  CountryCodeEnum.ZAF ? [
  {
    label: 'ZAR',
    value: CurrencyEnum.ZAR
  }
] : [
  {
    label: 'BRL',
    value: CurrencyEnum.BRL
  },
  {
    label: 'MXN',
    value: CurrencyEnum.MXN
  }
];

export const countryOptions = [
  // {
  //   label: 'All',
  //   value: selectionAllStatus
  // },
  {
    label: 'BRL',
    value: CurrencyEnum.BRL
  },
  {
    label: 'ZAR',
    value: CurrencyEnum.ZAR
  },
  {
    label: 'MXN',
    value: CurrencyEnum.MXN
  }
];

const currencyIntlRecord = (decimalNumber: number) => {
  return {
    [CurrencyEnum.BRL]: new Intl.NumberFormat('en', {
      style: 'currency',
      currencyDisplay: 'narrowSymbol',
      // currency: 'BRL',
      // currency: isBrazil() ? 'MXN' : 'BRL',
      currency: 'MXN',
      minimumFractionDigits: decimalNumber,
      maximumFractionDigits: decimalNumber
    }),
    [CurrencyEnum.USD]: new Intl.NumberFormat('en', {
      style: 'currency',
      currencyDisplay: 'narrowSymbol',
      currency: 'USD',
      minimumFractionDigits: decimalNumber,
      maximumFractionDigits: decimalNumber
    }),
    // [CurrencyEnum.ARS]: new Intl.NumberFormat('es', { style: 'currency', currencyDisplay: 'narrowSymbol', currency: 'ARS', minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    // [CurrencyEnum.NGN]: new Intl.NumberFormat('en', { style: 'currency', currencyDisplay: 'narrowSymbol', currency: 'NGN', minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    // [CurrencyEnum.USDT]: new Intl.NumberFormat('en', { style: 'currency', currencyDisplay: 'narrowSymbol', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 8 }),
    [CurrencyEnum.ZAR]: new Intl.NumberFormat('en', {
      style: 'currency',
      currencyDisplay: 'narrowSymbol',
      currency: 'ZAR',
      minimumFractionDigits: decimalNumber,
      maximumFractionDigits: decimalNumber
    }),
    [CurrencyEnum.MXN]: new Intl.NumberFormat('en', {
      style: 'currency',
      currencyDisplay: 'narrowSymbol',
      currency: 'MXN',
      minimumFractionDigits: decimalNumber,
      maximumFractionDigits: decimalNumber
    })
  } as const;
};

const currencyFormatRecord: Record<CurrencyEnum, (val: number, decimalNumber: number) => string> = {
  [CurrencyEnum.BRL]: (val, decimalNumber) => currencyIntlRecord(decimalNumber)[CurrencyEnum.BRL].format(+(new Decimal(val).toFixed(decimalNumber, Decimal.ROUND_FLOOR))).replace(/\u00a0/g, ''),
  [CurrencyEnum.USD]: (val, decimalNumber) => currencyIntlRecord(decimalNumber)[CurrencyEnum.USD].format(+(new Decimal(val).toFixed(decimalNumber, Decimal.ROUND_FLOOR))).replace(/\u00a0/g, ''),
  [CurrencyEnum.ZAR]: (val, decimalNumber) => currencyIntlRecord(decimalNumber)[CurrencyEnum.ZAR].format(+(new Decimal(val).toFixed(decimalNumber, Decimal.ROUND_FLOOR))).replace(/\u00a0/g, ''),
  [CurrencyEnum.MXN]: (val, decimalNumber) => currencyIntlRecord(decimalNumber)[CurrencyEnum.MXN].format(+(new Decimal(val).toFixed(decimalNumber, Decimal.ROUND_FLOOR))).replace(/\u00a0/g, '')
} as const;

export function formatCurrency(val: Decimal.Value, cc: CurrencyEnum, decimalNumber?: number) {
  if (currencyArray.includes(cc)) {
    return currencyFormatRecord[cc](new Decimal(val).toNumber(), decimalNumber || 2);
  } else {
    return '--';
  }
}

//定义汇率数据转换
const currencyRateIntlRecord = {
  [CurrencyRateEnum.USD]: new Intl.NumberFormat('en', {
    style: 'currency',
    currencyDisplay: 'narrowSymbol',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }),
  [CurrencyRateEnum.EUR]: new Intl.NumberFormat('en', {
    style: 'currency',
    currencyDisplay: 'narrowSymbol',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

} as const;
const currencyRateFormatRecord: Record<CurrencyRateEnum, (val: number) => string> = {
  [CurrencyRateEnum.USD]: (val) => currencyRateIntlRecord[CurrencyRateEnum.USD].format(+(new Decimal(val).toFixed(2, Decimal.ROUND_FLOOR))).replace(/\u00a0/g, ''),
  [CurrencyRateEnum.EUR]: (val) => currencyRateIntlRecord[CurrencyRateEnum.EUR].format(+(new Decimal(val).toFixed(2, Decimal.ROUND_FLOOR))).replace(/\u00a0/g, ''),
  [CurrencyRateEnum.ZAR]: (val) => currencyIntlRecord(2)[CurrencyEnum.ZAR].format(+(new Decimal(val).toFixed(2, Decimal.ROUND_FLOOR))).replace(/\u00a0/g, ''),
  [CurrencyRateEnum.BRL]: (val) => currencyIntlRecord(2)[CurrencyEnum.BRL].format(+(new Decimal(val).toFixed(2, Decimal.ROUND_FLOOR))).replace(/\u00a0/g, ''),
  [CurrencyRateEnum.MXN]: (val) => currencyIntlRecord(2)[CurrencyEnum.MXN].format(+(new Decimal(val).toFixed(2, Decimal.ROUND_FLOOR))).replace(/\u00a0/g, '')
} as const;

export function formatCurrencyRate(val: Decimal.Value, cc: CurrencyRateEnum) {
  if (currencyRateArray.includes(cc)) {
    return currencyRateFormatRecord[cc](new Decimal(val).toNumber());
  } else {
    return '--';
  }
}